<span class="task-view-followers__label">Подписчики</span>

@if (task(); as currentTask) {
  @for (user of currentTask.followersUsers; track user) {
    <ux-avatar
      class="task-view-followers__follower"
      [user]="user"
      (remove)="onDeleteFollower($event)"
      [showDeleteBtn]="user.id !== currentTask.responsibleId"
    >
    </ux-avatar>
  }

  <div class="task-view-followers__add">
    <span class="task-view-followers__add-btn" (click)="onToggle()">
      <i class="icon-plus"></i>
    </span>
    @if (isOpenPopup()) {
      <ux-popup-user
        class="task-view-followers__user-popup"
        [projectId]="currentTask.projectId"
        (changeItems)="onChangeFollowers($event)"
        [value]="currentTask.followers"
        [multiple]="true"
        header="Подписчики"
        (clickOutside)="onClose()"
        [delayClickOutsideInit]="true"
      >
      </ux-popup-user>
    }
  </div>
}
